<section class="bn-cs" [attr.aria-label]="resolvedAriaLabel()">
  <header class="bn-cs__header">
    <div class="bn-cs__title-row">
      <button
        type="button"
        class="bn-cs__collapse"
        [attr.aria-expanded]="expanded()"
        [attr.aria-label]="'Toggle ' + resolvedAriaLabel()"
        (click)="toggleExpanded()"
      >
        <i
          class="pi"
          [class.pi-chevron-down]="expanded()"
          [class.pi-chevron-right]="!expanded()"
          aria-hidden="true"
        ></i>
      </button>
      @if (icon(); as iconClass) {
        <i [class]="iconClass + ' bn-cs__icon'" aria-hidden="true"></i>
      }
      <h2 class="bn-cs__title">{{ title() }}</h2>
      <ng-content select="[sectionHeaderExtra]" />
    </div>
  </header>

  @if (expanded()) {
    <div class="bn-cs__body">
      <ng-content />
    </div>
  }
</section>
